






























import { defineComponent, PropType, ref } from '@nuxtjs/composition-api'
import CStarRating from '~/components/shared/configurable/rating/CStarRating.vue'
import MarketplaceSellerInfoModal from '~/components/car/marketplace/seller/MarketplaceSellerInfoModal.vue'
import { CartSellerInfo } from '~/models/marketplace/cart'

export default defineComponent({
  components: { MarketplaceSellerInfoModal, CStarRating },
  props: {
    seller: {
      type: Object as PropType<CartSellerInfo>,
      required: true
    }
  },
  setup() {
    const showSellerModal = ref(false)

    function onRatingClick() {
      showSellerModal.value = true
    }

    function onSellerModalHide() {
      showSellerModal.value = false
    }

    return {
      showSellerModal,
      onSellerModalHide,
      onRatingClick
    }
  }
})
